import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { TrackProductClick } from '@app/+catalog/store';

/**
 * When the user applies a filter to a product list.
 */
const events = getEvents(
  ({
    payload: { keyword, position, indexName, productId, perso_created, perso_enabled, perso_product_click }
  }: TrackProductClick) => [
    {
      type: 'event',
      container: TagContainer.Analytics,
      payload: {
        event: 'clickResults',
        keyword: keyword,
        position: position,
        index_name: indexName,
        product_id: productId,
        perso_created,
        perso_enabled,
        perso_product_click
      }
    }
  ]
);

export default events;
